import i18n from "@/i18n";
import { resolveLanguage } from "@/i18n/languages";
import { ENGINE_NS, useCatalogs } from "@/i18n/lazyCatalogs";

// Solo la ve un miembro del Engine: /api/engine/me no ha respondido. Aun no hay despacho cargado,
// asi que el idioma sale de la preferencia del usuario o del navegador.
export default function AccessCheckError({ user, onRetry }) {
    const lang = resolveLanguage({ member: true, user, navigatorLanguages: navigator.languages });
    useCatalogs(ENGINE_NS, lang);
    const t = i18n.getFixedT(lang, "engine");
    return (
        <div role="alert" className="min-h-screen flex flex-col items-center justify-center gap-3 p-6 text-center">
            <p className="text-graphite">{t("access.error")}</p>
            <button type="button" className="rounded-md border border-soft_border px-4 py-2 min-h-11 text-petrol" onClick={onRetry}>{t("access.retry")}</button>
        </div>
    );
}
